module.exports = __webpack_public_path__ + "img/downloadApp6.ed416fb5.svg";